import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const CartContext = createContext(null);
const KEY = 'ndp_cart_v1';
export const k = (i) => i.key || i.variant_sku;

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const api = useMemo(() => ({
    items,
    open,
    setOpen,
    count: items.reduce((a, i) => a + i.qty, 0),
    subtotal: items.reduce((a, i) => a + i.qty * (i.price || 0), 0),
    add: (raw) => {
      const line = { ...raw, key: [raw.variant_sku, raw.personalisation || '', raw.gift_message || ''].join('|') };
      setItems((prev) => {
        const ex = prev.find((i) => k(i) === line.key);
        if (ex) return prev.map((i) => (k(i) === line.key ? { ...i, qty: Math.min(i.qty + line.qty, line.max || 99) } : i));
        return [...prev, line];
      });
      setOpen(true);
    },
    setQty: (key, qty) => setItems((prev) => prev.map((i) => (k(i) === key ? { ...i, qty: Math.max(1, Math.min(qty, i.max || 99)) } : i))),
    remove: (key) => setItems((prev) => prev.filter((i) => k(i) !== key)),
    clear: () => setItems([]),
  }), [items, open]);

  return <CartContext.Provider value={api}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
